export default __webpack_public_path__ + "static/media/TimelineOn.7e796f6a.webp";